//      
import {connect} from "react-redux";
                                                  
import PriceBox from "../components/PriceBox";
import {withTranslation} from "react-i18next";
import {addToCart, removeFromCart} from "../actions/cart";
                                    
import {CART_MAX_ITEMS} from "../reducers/cartReducer";
import {hasNoPrice} from "../helper/priceUtil";
import {toast} from "react-toastify/unstyled";
                                            

                                

function mapStateToProps(state                  , ownProps                        ) {
	return {
		detailedProduct: state.content.activeProduct,
		isInCart: state.cart.items.some(item => item.id === state.content.activeProduct.product.id),
		cartDisabled: state.cart.cartDisabled,
		hidePrices: state.cart.hidePrices || hasNoPrice(state.content.activeProduct.product),
		showMsrp: state.config.showMsrp,
		disclaimer: state.content.disclaimer,
		isCartLimitReached: state.cart.items.length >= CART_MAX_ITEMS,
	};
}

function mapDispatchToProps(dispatch          , ownProps                        ) {
	return {
		addToCart: (t           ) => {
			dispatch(addToCart(ownProps.product));
			toast(t("cart.add"));
		},
		removeFromCart: () => {
			dispatch(removeFromCart(ownProps.product));
		},
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(PriceBox));
